import { useState, useEffect } from 'react'
import { ClientsType, ManagerType } from '../../../redux/actions/types'

export const useClientSelection = (claimData: any, clients: ClientsType[]) => {
  const [clientType, setClientType] = useState<'individual' | 'legal'>('individual')
  const [selectedClient, setSelectedClient] = useState<any>(claimData?.client?.id || '')
  const [clientManagers, setClientManagers] = useState<ManagerType[]>([])

  useEffect(() => {
    if (claimData?.client?.type) {
      setClientType(claimData.client.type as 'individual' | 'legal')
    }
  }, [claimData?.client])

  useEffect(() => {
    if (selectedClient && clients) {
      const filteredClient = clients.find((client: ClientsType) => client.id == selectedClient)
      if (filteredClient) {
        setClientManagers(filteredClient?.managersData || [])
      } else {
        setClientManagers([])
      }
    }
  }, [selectedClient, clients])

  useEffect(() => {
    if (claimData?.client?.id && claimData.client.id !== selectedClient) {
      setSelectedClient(claimData.client.id)
    }
  }, [claimData?.client?.id])

  const clientOptions =
    clients
      ?.filter((c: ClientsType) => c.type === clientType)
      .map((c: ClientsType) => ({
        value: c?.id,
        label: c?.organizationName || c?.fullName,
      })) || []

  const loadOptions = (inputValue: string, callback: (options: any[]) => void) => {
    const filtered = clientOptions?.filter((option: any) =>
      option?.label.toLowerCase().includes(inputValue.toLowerCase()),
    )
    callback(filtered)
  }

  return {
    clientType,
    selectedClient,
    clientManagers,
    setClientType,
    setSelectedClient,
    clientOptions,
    loadOptions,
  }
}
